import { useBreakpointValue, useMediaQuery } from '@chakra-ui/react';
import { NO_HOVER_QUERY } from '../constants/media';

type Breakpoint = 'sm' | 'md' | 'lg' | 'xl' | '2xl';

// `ssr: false` matters: by default Chakra returns the base (phone) value on the
// first render, so effects keyed on it run as if every screen were a phone.
export const useIsBelowBreakpoint = (breakpoint: Breakpoint): boolean =>
	useBreakpointValue({ base: true, [breakpoint]: false }, { ssr: false }) ??
	false;

export const useIsPhoneLayout = (): boolean => useIsBelowBreakpoint('md');

export const useIsNoHoverDevice = (): boolean =>
	useMediaQuery(NO_HOVER_QUERY, { ssr: false })[0];
